import { render, staticRenderFns } from "./EditCustomerInCommercial.vue?vue&type=template&id=b769f1fc&"
import script from "./EditCustomerInCommercial.vue?vue&type=script&lang=js&"
export * from "./EditCustomerInCommercial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports